module.exports = __webpack_public_path__ + "img/chat.0b72bd0b.svg";